import React, { useEffect, useRef, useState } from 'react';
import { BranchBase } from './branchBase.js';
import * as R from 'ramda';
import {CustomBranch} from './customBranch';
import {ConnectionTypes} from '../../../../../../../constants/utils/connectionTypes';

export const BranchService = ({ connectionType, title, serviceDatas, isLoading, userId, displayComments, disableModifications, generateLetters }) => {
    const [resetPage, setResetPage] = useState(false);
    const bottomRef = useRef(null);
    const [branches, setBranches] = useState({ items: [] });
    const [showCustomBox, setShowCustomBox] = useState(false);
    const [canCollapse, setCanCollapse] = useState(false);
    const [addedNew, setAddedNew] = useState(false);
    const [allBranches, setAllBranches] = useState([]);

    function removeBranch(serviceId) {
        let tmpItems = branches.items.filter(b => !R.isNil(serviceId) && !R.isNil(b) ? serviceId !== b.serviceId: !R.isNil(b));
        setBranches({ ...branches, items: tmpItems });
        if (tmpItems.length === 0){
            setResetPage(true);
        }
    }

    useEffect(() => {
        if (!R.isNil(connectionType)) {
            if (serviceDatas.length > 0) {
                setBranches({ items: R.sortWith([R.ascend(R.prop('position'))])(serviceDatas) });
            } else {
                setBranches({ ...branches, items: [] });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceDatas]);

    useEffect(() => {
        if (!R.isNil(connectionType)) {
            setCanCollapse(false);
            setAddedNew(false);
            setShowCustomBox(false);
            setResetPage(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionType]);

    useEffect(() => {
        setTimeout(() => {
            setResetPage(false);
        }, 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetPage]);

    useEffect(() => {
        if (addedNew === true && !R.isNil(bottomRef) && !R.isNil(bottomRef.current)) {
            bottomRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
        setAddedNew(false);
    }, [addedNew]);

    useEffect(() => {    
        let lastPosition = R.isEmpty(branches.items) ? 0 : (Math.max(...branches.items.filter(b => !R.isNil(b)).map(b => b.position)) + 1);
        const tmpAllBranches = [];
        branches.items.map((sData, sDataIndex) => {            
            let tmpPosition = R.isNil(sData) ? lastPosition++ : sData.position;
            const isMain = sDataIndex === 0;
            if (!R.isNil(sData) && sData.serviceId.toLowerCase().startsWith('custom') && !tmpAllBranches.some(t => t.serviceId === sData.serviceId)) {
                    tmpAllBranches.push({ pos: tmpPosition, serviceId: sData.serviceId, data: <CustomBranch title={title} isMain={isMain} removeBranch={removeBranch} key={"custom" + sDataIndex} boxIndex={"custom" + sDataIndex} connectionType={connectionType} customServiceData={sData} setShowCustomBox={setShowCustomBox} totalBranches={branches.items.length} canCollapse={canCollapse} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters} /> });
            }
            else {
                if(R.isNil(sData)){
                    tmpAllBranches.push({ pos: tmpPosition, serviceId: sData?.serviceId, data: <BranchBase isMain={isMain} bottomRef={sDataIndex === branches.items.length - 1 ? bottomRef : undefined} removeBranch={removeBranch} canCollapse={canCollapse} title={title} connectionType={connectionType} key={sDataIndex} index={sDataIndex} branch={sData} totalBranches={branches.items.length} setShowCustomBox={setShowCustomBox} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters}/> });
                }else{
                    // if(!tmpAllBranches.some(t => t.serviceId === sData.serviceId)){
                    //     tmpAllBranches.push({ pos: tmpPosition, serviceId: sData?.serviceId, data: <BranchBase isMain={isMain} bottomRef={sDataIndex === branches.items.length - 1 ? bottomRef : undefined} removeBranch={removeBranch} canCollapse={canCollapse} title={title} connectionType={connectionType} key={sDataIndex} index={sDataIndex} branch={sData} totalBranches={branches.items.length} setShowCustomBox={setShowCustomBox} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters}/> });
                    // }
                    tmpAllBranches.push({ pos: tmpPosition, serviceId: sData?.serviceId, data: <BranchBase isMain={isMain} bottomRef={sDataIndex === branches.items.length - 1 ? bottomRef : undefined} removeBranch={removeBranch} canCollapse={canCollapse} title={title} connectionType={connectionType} key={sDataIndex} index={sDataIndex} branch={sData} totalBranches={branches.items.length} setShowCustomBox={setShowCustomBox} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters}/> });
                }
                    
            }

        });
    
        if (tmpAllBranches.length === 0 && showCustomBox === false){
            tmpAllBranches.push({pos: 0, data:<BranchBase removeBranch={removeBranch} canCollapse={canCollapse} title={title} isMain={true} connectionType={connectionType} index={0} totalBranches={branches.items.length} setShowCustomBox={setShowCustomBox} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters} />});
        }
        setAllBranches(R.sortWith([R.ascend(R.prop('pos'))])(tmpAllBranches));
    }, [branches]);

    return (
        <article className="block" id={title}>
            <h3 className="sr-only visually-hidden">{title}</h3>
            {resetPage === false && allBranches.map(b => b.data)}
            {
                showCustomBox ? <CustomBranch title={title} removeBranch={removeBranch} key={"custom"} boxIndex={branches.items.length} isMain={branches.items.length === 0} connectionType={connectionType} customServiceData={null} setShowCustomBox={setShowCustomBox} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={displayComments} disableModifications={disableModifications} generateLetters={generateLetters}/> : ''
            }

            <footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
                <h4 className="sr-only visually-hidden">Add new</h4>
                <button type="button" className="btn btn-icon btn-alert-info mx-auto py-2" disabled={R.isNil(branches.items[branches.items.length - 1]) || showCustomBox} onClick={(e) => {
                    const nodes = window.document.querySelectorAll('.collapse.show');
                    if (!R.isNil(nodes) && nodes.length > 0) {
                        nodes.forEach(element => {
                            element.classList.remove(['show']);
                        });
                    }
                    e.preventDefault();
                    setCanCollapse(true);
                    setBranches({ ...branches, items: [...branches.items, undefined] });
                    setAddedNew(true);
                }}>
                    <i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter un autre {title.toUpperCase()}
                </button>
            </footer>
        </article>
    );
}